import React, { useState, useCallback, useContext, useEffect } from 'react';
//import { Select, MenuItem } from '@material-ui/core';
import { SapInitiativesProvider, SapInitiativesContext } from './SapInitiativesContext';
import { NavContext, NavRoutes, UserContext, HttpMethods, FetchContext, ApiRoutes, ToastContext } from '../../../contexts';
//import { makeStyles } from '@material-ui/core/styles';
//import { InputFiles } from '../../../common';
import clsx from 'clsx';
import { useDropzone } from 'react-dropzone';

import {
    Button,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
    Tooltip,
    CircularProgress,
    colors,
    Select,
    MenuItem,
    LinearProgress
} from '@material-ui/core';

import PublishIcon from '@material-ui/icons/Publish';
import DeleteIcon from '@material-ui/icons/Delete';

import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    yearsContainer: {
        display: 'flex',
        marginBottom: '50px'
    },
    yearsDescription: {
        alignSelf: 'center',
        fontSize: '1rem'
    },
    yearsSelection: {
        width: "90px",
        marginLeft: "20px",
        height: '40px'
    },
    root: {

    },
    title: {
        textAlign: 'center',
        fontSize: '22px',
        fontWeight: 500,
        marginBottom: '30px',
        marginTop: '10px'
    },
    dropZone: {
        height: "200px",
        border: "2px dashed #c2a07b",
        padding: "8px",
        outline: "none",
        display: "flex",
        flexWrap: "wrap",
        backgroundColor: "#e1e1e1",
        opacity: 1,
        "&:hover": {
            backgroundColor: "#f1f1f1",
            opacity: 1,
            cursor: "pointer"
        }
    },
    dragActive: {
        backgroundColor: colors.grey[50],
        opacity: 0.5
    },
    image: {
        width: 130
    },
    infoContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    info: {
        marginTop: 1,
        alignSelf: 'center'
    },
    list: {
        maxHeight: 320
    },
    actions: {
        marginTop: 2,
        display: "flex",
        justifyContent: "flex-end",
        "& > * + *": {
            marginLeft: 2
        }
    },
    removeButton: {
        marginRight: 10
    },
    loaderContainer: {
        textAlign: 'center',
        marginTop: '50px'
    }
}));

const PageContent = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const { showSuccessMessage, showWarningMessage, showErrorMessage } = useContext(ToastContext);
    const classes = useStyles();
    const { setBreadcrumbRoot, addBreadcrumbToken } = useContext(NavContext);

    const {
        budgetYears
    } = useContext(UserContext);

    const {
      state,
      importActualAsync
    } = useContext(SapInitiativesContext);

    const {
        isLoadingUploadArea,
        updatedValues
    } = state;
  
    useEffect(() => {
		addBreadcrumbToken("Upload SAP initiatives");
    }, [])
  
    const [files, setFiles] = useState([]);
    const [excelId, setExcelId] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [isLoading, setIsLoading] = useState(null);

    useEffect(() => {
        if (budgetYears !== null){
            let activeYears = [];
            if (budgetYears.items && budgetYears.items.length > 0){
                budgetYears.items.map(session => {
                    if (session.isActive)
                        activeYears.push(session.observedYear);
                });

                //default year is the first active one...
                if (activeYears.length > 0)
                    setSelectedYear(activeYears[0]);
                //...or it is the first year in general
                else
                    setSelectedYear(budgetYears.items[0].observedYear);
            }
        }
    }, [budgetYears])

    useEffect(() => {
      if (selectedYear !== null && excelId !== null){
        sendDataAsync();

        async function sendDataAsync(){
          setIsLoading(true);
          await importActualAsync({ sourceYear: selectedYear, listFileId: excelId });
          setIsLoading(false);
        }
      }
    }, [selectedYear, excelId])

    useEffect(() => {
      if (updatedValues !== null){
        if (updatedValues.length > 0)
            showSuccessMessage(`Actual values have been succesfully imported`);
        else if (updatedValues.length == 0)
            showWarningMessage('No Sap Initiative match found!');

        removeAllFilesClickHandler();
      }
    }, [updatedValues])

    const handleDrop = useCallback((acceptedFiles) => {
        const fileExtension = acceptedFiles[0] && acceptedFiles[0].name && acceptedFiles[0].name.split(".").pop();
        
        if (fileExtension === "csv" || fileExtension === "xls" || fileExtension === "xlsx")
            setFiles((prevFiles) => [...prevFiles].concat(acceptedFiles));
        else
            showErrorMessage("only excel files are allowed");
    }, []);

    const removeFileClickHandler = (index) => {
        const newFiles = [].concat(files)
        newFiles.splice(index, 1)
        setFiles(newFiles)
    }

    const removeAllFilesClickHandler = () => {
        setFiles([]);
        setExcelId(null);
    }

    const [isUploading, setIsUploading] = useState(false);
    const uploadAllFilesClickHandler = async () => {
        
        setIsUploading(true);
        for(const file of files) {
            try {
                const data = new FormData();
                data.append("file", file);
                const r = await fetchAuthorized(ApiRoutes.File.Upload(),
                {                    
                    method: HttpMethods.POST,                    
                    body: data
                });

                const uploadedFile = await r.json();
                setFiles((prevFiles) => [...prevFiles].filter(x => x.name !== file.name));

                setExcelId(uploadedFile.storedFileId);

                //notifyFileUploaded(uploadedFile);

                //showSuccessMessage(`File '${file.name}' has been uploaded`);

            } catch(e) {
                console.debug(e);                
            }        
        }

        setIsUploading(false);
    }

    /*const notifyFileUploaded = (storedFile) => {
        if(onFileUploaded) onFileUploaded(storedFile);
    }*/

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: handleDrop
    });
    
    return (
        <div>
            {isLoadingUploadArea ?
            <LinearProgress color="primary" /> :
            <>
                <div className={classes.title}>
                    Upload SAP initiatives to import Actual values
                </div>
                <div className={classes.yearsContainer}>
                    <div className={classes.yearsDescription}>
                        Select the year of the projects
                    </div>
                    <Select
                        className={classes.yearsSelection}
                        value={selectedYear ? selectedYear : ""}
                        variant="outlined"
                        onChange={x => setSelectedYear(x.target.value)}
                    >
                        {budgetYears &&
                        budgetYears.items &&
                        budgetYears.items.length > 0 &&
                        budgetYears.items.map((year, index) => {
                            return (
                                <MenuItem key={index} value={year.observedYear}>
                                    {year.observedYear}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
                {/* <InputFiles /> */}
                <div
                    className={clsx({
                        [classes.dropZone]: true,
                        [classes.dragActive]: isDragActive
                    })}
                    {...getRootProps()}>
                    <input {...getInputProps()} />
                    <div className={classes.infoContainer}>
                        {/* <Typography
                            gutterBottom
                            variant="h6">
                            {"title"}
                        </Typography> */}
                        <Typography
                            className={classes.info}
                            color="textSecondary"
                            variant="body1">
                            Drop files here or click
                            {' '}
                            <Link color="textSecondary" underline="always">browse</Link>
                            {' '}
                            thorough your machine
                        </Typography>
                    </div>
                </div>
                {files && files.length > 0 && (
                    <>
                        <List className={classes.list}>
                            {files.map((file, i) => (
                                <ListItem
                                    divider={i < files.length - 1}
                                    key={i}>
                                    <ListItemIcon>
                                        {!isUploading ? 
                                            <PublishIcon />
                                            :
                                            <CircularProgress size="1.6em" color="primary" />
                                        }
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={file.name}
                                        primaryTypographyProps={{ variant: 'body1' }} />
                                    {!isUploading && 
                                        <Tooltip title="Remove">
                                            <IconButton
                                                color="primary"                                        
                                                edge="end"                                            
                                                onClick={() => removeFileClickHandler(i)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </ListItem>
                            ))}
                        </List>
                        <div className={classes.actions}>
                            <Button                            
                                color="primary"
                                className={classes.removeButton}
                                size="small"
                                disabled={isUploading}
                                onClick={removeAllFilesClickHandler}>
                                Remove all
                            </Button> 
                            <Button                        
                                color="primary"
                                size="small"
                                variant="contained"
                                disabled={isUploading || !selectedYear}
                                onClick={uploadAllFilesClickHandler}>
                                Upload files
                            </Button>
                        </div>
                    </>
                )}

                {
                    isLoading &&
                    <div className={classes.loaderContainer}>
                        <CircularProgress color="primary" />
                    </div>
                }
            </>
            }
        </div>
    );
}

export const SapInitiativesPage = () => {

    return (
        <SapInitiativesProvider>
            <PageContent />
        </SapInitiativesProvider>
    );
}



